import { ICompany } from 'app/shared/model/company.model';

export interface IRepresentativeCompany {
  id?: number;
  company?: ICompany | null;
  targetCompany?: ICompany | null;
}

export const defaultValue: Readonly<IRepresentativeCompany> = {};
